// src/categories/anxiety.js
const KEY = "anxiety";
const TITLE = "Anxiety Sensations";
const SUBTITLE = "A Healing Sensation";

const SENSATIONS = [
  "RACING HEART",
  "SHALLOW BREATHING",
  "TIGHT CHEST",
  "STOMACH BUTTERFLIES",
  "TENSE MUSCLES",
  "SWEATING PALMS",
  "DIZZINESS OR LIGHTHEADEDNESS",
  "COLD HANDS OR FEET",
  "RESTLESSNESS",
  "IRRITABILITY",
  "HEADACHE OR TENSION",
  "RUMINATING THOUGHTS",
  "DIFFICULTY FOCUSING",
  "FLUSHING OR BLUSHING",
  "NECK OR SHOULDER TIGHTNESS",
  "FEELING ON EDGE",
  "DRY MOUTH",
  "SENSITIVITY TO NOISE",
  "NEED TO MOVE OR PACING",
  "TREMBLING OR SHAKING",
  "FEAR OF LOSING CONTROL",
  "RAPID THINKING",
  "OVERSENSITIVITY TO ENVIRONMENT",
  "SLEEP DISTURBANCE",
];

const DISH_NAMES = {
  "RACING HEART": "Heart Rush",
  "SHALLOW BREATHING": "Light Breath",
  "TIGHT CHEST": "Chest Grip",
  "STOMACH BUTTERFLIES": "Butterfly Stomach",
  "TENSE MUSCLES": "Muscle Knot",
  "SWEATING PALMS": "Sweaty Palms",
  "DIZZINESS OR LIGHTHEADEDNESS": "Light Spin",
  "COLD HANDS OR FEET": "Chill Extremities",
  "RESTLESSNESS": "Fidget Storm",
  "IRRITABILITY": "Frayed Nerves",
  "HEADACHE OR TENSION": "Tension Head",
  "RUMINATING THOUGHTS": "Thought Spiral",
  "DIFFICULTY FOCUSING": "Focus Fog",
  "FLUSHING OR BLUSHING": "Face Warmth",
  "NECK OR SHOULDER TIGHTNESS": "Shoulder Brace",
  "FEELING ON EDGE": "Edge Awareness",
  "DRY MOUTH": "Parched Mouth",
  "SENSITIVITY TO NOISE": "Noise Alert",
  "NEED TO MOVE OR PACING": "Movement Urge",
  "TREMBLING OR SHAKING": "Shaky Limbs",
  "FEAR OF LOSING CONTROL": "Control Fear",
  "RAPID THINKING": "Thought Sprint",
  "OVERSENSITIVITY TO ENVIRONMENT": "Hyper-Alert",
  "SLEEP DISTURBANCE": "Restless Mind",
};

const ENCOURAGEMENTS = {
  "RACING HEART":
    "Your heart speeds up because adrenaline is preparing you for action — it’s your body’s natural alarm system working as intended.",

  "SHALLOW BREATHING":
    "Short, rapid breaths bring oxygen to muscles quickly. Your body is signaling readiness, not danger.",

  "TIGHT CHEST":
    "Chest tightness comes from your diaphragm and muscles tensing — a protective mechanism, signaling your body to focus inward and prepare.",

  "STOMACH BUTTERFLIES":
    "That fluttering comes from your gut-brain axis — your nervous system is processing stress and preparing your body for change.",

  "TENSE MUSCLES":
    "Muscle tension is your body’s way of priming for movement. It’s natural and will release once the perceived threat diminishes.",

  "SWEATING PALMS":
    "Sweat glands activate to cool you down and improve grip — a healthy stress response.",

  "DIZZINESS OR LIGHTHEADEDNESS":
    "This often occurs when blood flow is redirected to essential muscles. It’s temporary and part of your fight-or-flight preparation.",

  "COLD HANDS OR FEET":
    "Peripheral blood vessels constrict to prioritize core organs — your body is optimizing resources.",

  "RESTLESSNESS":
    "Restlessness is energy mobilization. Your body is trying to process stress safely.",

  "IRRITABILITY":
    "Mood shifts occur due to heightened cortisol levels — a temporary alert system, not a flaw.",

  "HEADACHE OR TENSION":
    "Tension headaches are caused by muscle tightening in response to stress — a signal to pause and release tension.",

  "RUMINATING THOUGHTS":
    "Repeated thoughts are your brain trying to problem-solve and make sense of stress — it’s an adaptive pattern.",

  "DIFFICULTY FOCUSING":
    "Attention shifts under stress to prioritize survival. Distraction is your brain’s way of triaging threats.",

  "FLUSHING OR BLUSHING":
    "Blood vessels dilate to regulate temperature — a harmless physiological reaction to emotional arousal.",

  "NECK OR SHOULDER TIGHTNESS":
    "Muscles tighten to protect the spine and posture. Awareness and gentle movement release the tension.",

  "FEELING ON EDGE":
    "Heightened alertness is your nervous system checking for threats — a normal self-regulation response.",

  "DRY MOUTH":
    "Saliva production decreases to divert the energy to vital organs, preparing you to accomodate threats — temporary and harmless.",

  "SENSITIVITY TO NOISE":
    "Your auditory system is primed to detect danger — it’s a built-in protective mechanism.",

  "NEED TO MOVE OR PACING":
    "Movement helps process excess adrenaline and restore balance — your body knows how to self-regulate.",

  "TREMBLING OR SHAKING":
    "Shaking muscles release adrenaline and help your system reset — it’s your body letting off stress safely.",

  "FEAR OF LOSING CONTROL":
    "Fear arises from the amygdala activating threat circuits — your mind is predicting and preparing, not failing.",

  "RAPID THINKING":
    "Quick thoughts are your brain scanning options and prioritizing survival. It’s a temporary cognitive boost.",

  "OVERSENSITIVITY TO ENVIRONMENT":
    "Heightened perception is your nervous system tuning in to subtle cues — a natural self-protection mode.",

  "SLEEP DISTURBANCE":
    "Rest interruptions occur because cortisol levels rise — your body is processing stress signals and recalibrating.",
};

export default { KEY, TITLE, SUBTITLE, SENSATIONS, DISH_NAMES, ENCOURAGEMENTS };
